import { MiniUsersResponseInterface } from "../users/users-response.interface";
import { CompanyResponseInterface } from "../companies/company-response.interface";
import { Brand, CategoryTypes, ProductCategory } from "../../utils/enums.utils";
import { AttachmentsResponseInterface } from "../attachments/attachments-response.interface";

export interface ProposalsResponseInterface {
  id: string;
  project_name: string;
  project_code: string | null;
  category: CategoryTypes;
  product_category: ProductCategory;
  company: ProposalCompanies;
  selected_date: string;
  customer_ref: string | null;
  quotation_number: string | null;
  payment_terms: ProposalPaymentTerms;
  quote_validity: ProposalValidity;
  warranty: ProposalWarranty;
  company_remarks: string | null;
  status: ProposalStatus;
  created_at: string | null;
  updated_at: string | null;
  company_ref: CompanyResponseInterface;
  proposal_attachments: ProposalAttachmentsResponseInterface[] | null;
  proposal_items: ProposalItemsResponseInterface[] | null;
  proposal_pricing_summary: ProposalPricingSummaryResponseInterface | null;
  created_by: MiniUsersResponseInterface | null;
  updated_by: MiniUsersResponseInterface | null;
}

export interface ProposalAttachmentsResponseInterface {
  proposal_id: string;
  attachment: AttachmentsResponseInterface;
  status: ProposalAttachmentsStatus;
}

export enum ProposalAttachmentsStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export interface ProposalItemsResponseInterface {
  id: string;
  item_details: string | null;
  description: string | null;
  quantity: number | null;
  uom: string | null;
  buying_vat_inc: number | null;
  total_buying: number | null;
  shipping_fee: number | null;
  wsf: number | null;
  markup: number | null;
  sp: number | null;
  sp_each: number | null;
  misc: number | null;
  tpc_price: number | null;
  fsp: number | null;
  fsp_each: number | null;
  profit_each: number | null;
  total_profit: number | null;
  delivery: string | null;
  lof: string | null;
  aof: string | null;
  srf: string | null;
  lsf: string | null;
  project: string | null;
  brand: Brand;
  proposal_id: string;
  attachment_item_img: AttachmentsResponseInterface | null;
  status: ProposalItemStatus;
}

export interface ProposalPricingSummaryResponseInterface {
  id: string;
  subtotal: number;
  shipping_fee: number;
  markup: number;
  misc: number;
  approval_discount: number;
  discount_percent: number;
  discount_amount: number;
  total_ex_vat: number;
  total_inc_vat: number;
  total_profit: number;
  grand_total: number;
  lead_time: string | null;
  created_at: string | null;
  updated_at: string | null;
  proposal_id: string;
  status: ProposalPricingSummaryStatus;
}

export enum ProposalStatus {
  PENDING = 'Pending',
  RETURNED = 'Returned',
  REJECTED = 'Rejected',
  APPROVED = 'Approved',
  DRAFT = 'Draft',
  DELETED = 'Deleted',
}

export enum ProposalItemStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  DELETED = 'Deleted',
}

export enum ProposalPricingSummaryStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  DELETED = 'Deleted',
}

export enum ProposalCompanies {
  ACA = 'ACA',
  PII = 'PII'
}

export enum ProposalPaymentTerms {
  DP30_UD70 = '30% Downpayment , 70% Upon Delivery',
  DP50_UD50 = '50% Downpayment , 50% Upon Delivery',
  UD100 = '100% Upon Delivery',
  DAYS_30 = '30 Days Payment Terms',
  DAYS_120 = '120 Days Payment Terms',
}

export enum ProposalValidity {
  DAYS_15 = '15 Days Validity',
  DAYS_30 = '30 Days Validity',
  DAYS_60 = '60 Days Validity',
}

export enum ProposalWarranty {
  MONTHS_6 = '6 Months Warranty',
  MONTHS_9 = '9 Months Warranty',
  MONTHS_12 = '12 Months Warranty',
}